import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *已选中列表
 * @param params
 * 
*/

export const pickList = params => Http.get(`${baseUrl}/activity/pick`, { params })
